import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";

import { Button, IllustrationManifest, tokens } from "@manifesthhqinc/ui-library";
import * as Styled from "../post-transfer/styles";

import { HeadlineMedium, BodyMediumRegular } from "../../components/font";
import useTransferTasks from "./useTransferTasks";
import { STEP_SPOUSE_NOTARY } from "../../class/transferDetails";
import ScrollableContainer from "../../layout/scrollable-container";
import Container from "../../layout/container";
import Flex from "../../layout/flex";
import Footer from "../../components/footer";
import { LoadingContainer } from "../destination-account/screens/styles";

import Spinner from "../../components/spinner";
import { COLOR_MANIFEST_TEAL } from "../../styles/globalStylesVariables";

const TransferTasks = () => {
  const { currentScreen, onClickGotIt } = useTransferTasks();

  if (currentScreen === STEP_SPOUSE_NOTARY) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="phone-call-needed-screen">
          <Container>
            <Flex $flexGap={8} $flexDirection="column">
              <HeadlineMedium $textAlign="center">
                Lastly, it’s common for an annuity to require spousal consent
              </HeadlineMedium>
              <BodyMediumRegular $textAlign="center">
                We’ll send your spouse a secure email with simple steps to sign through an online notary.
              </BodyMediumRegular>
            </Flex>
            <Styled.VectorWrapper>
              <IllustrationManifest width={200} />
            </Styled.VectorWrapper>
          </Container>
        </ScrollableContainer>
        <Footer>
          <BodyMediumRegular $color={tokens.color.text.secondary} $textAlign="center">
            No action needed on your end – we've got everything covered!
          </BodyMediumRegular>
          <Button name="continue" onClick={onClickGotIt} size="large">
            Got it!
          </Button>
        </Footer>
      </TransitionWrapper>
    );
  }

  return (
    <>
      <LoadingContainer>
        <Styled.PhoneCallLoadingScreen>
          <Spinner size={35} color={COLOR_MANIFEST_TEAL} />
        </Styled.PhoneCallLoadingScreen>
      </LoadingContainer>
    </>
  );
};

export default TransferTasks;
